import { H } from '../highway';
import { gsap } from 'gsap';
import { mq } from '../util/matchMedia';
import { readGlobalState, setGlobalState } from '../util/helpers';

export const navigation = (() => {
  let navigationBackground, navigationList, button, links, logo;

  const init = () => {
    setGlobalState('navigationOpen', false);
    getReferenceElements();
    setupNavigation();
  }

  const getReferenceElements = () => {
    navigationBackground = document.querySelector('.js-navigation-background');
    navigationList = document.querySelector('.js-navigation-list');
    button = document.querySelector('.js-open-navigation');
    links = document.querySelectorAll('.js-navigation-link');
    logo = document.querySelector('.js-navigation-logo');
  }

  const setupNavigation = () => {
    if (readGlobalState('mq') === 'mobile') {
      addMobileNavEventListeners();
    }
  }

  const addMobileNavEventListeners = () => {
    // mq.mql.addEventListener('change', setupNavigation);
    try {
      mq.mql.addEventListener('change', setupNavigation);
    } catch(e) {
      mq.mql.addListener(setupNavigation);
    }
    button.addEventListener('click', toggleNavigation);
    logo.addEventListener('click', closeNavigation);
    links.forEach(link => link.addEventListener('click', closeNavigation));
  }

  const toggleNavigation = () => {
    const isOpen = readGlobalState('navigationOpen');
    setGlobalState('navigationOpen', !isOpen);
    isOpen ? closeNavigation() : openNavigation()
  }

  const openNavigation = () => {
    setGlobalState('navigationOpen', true);
    document.body.classList.add('navigation-open');

    const tl = gsap.timeline();
    tl.to(navigationBackground, { y: 0, overwrite: true })
      .to(navigationList, { height: 'auto', overwrite: true }, 0)
      .to(links, {
        autoAlpha: 1,
        stagger: 0.1,
        duration: 0.3,
        overwrite: true,
      });
  }

  const closeNavigation = () => {
    setGlobalState('navigationOpen', false)
    document.body.classList.remove('navigation-open');

    const tl = gsap.timeline({ overwrite: true });
    tl
      .to(links, { autoAlpha: 0, duration: 0.05, overwrite: true }, 0)
      .to(navigationBackground, { y: '-101%', duration: 0.5, overwrite: true })
      .to(navigationList, { height: '0', duration: 0.5, overwrite: true }, '<')

  }

  const highlightActiveLink = () => {
    links.forEach(link => {
      if (link.href !== location.href) {
        link.classList.remove('is-active');
      } else {
        link.classList.add('is-active');
      }
    });
  }

  H.on('NAVIGATE_IN', highlightActiveLink);

  return { init, highlightActiveLink };
})();